import { Button, Skeleton } from "antd";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { ServerErrorAlert } from "../components/ServerError";
import type { Resource } from "./api";

/** Standard loading / error rendering for a resource; errors are explained in plain words. */
export function Loadable<T>({ r, children, rows = 4 }: { r: Resource<T>; children: (data: T) => ReactNode; rows?: number }) {
  const { t } = useTranslation("common");
  if (r.error)
    return (
      <ServerErrorAlert
        testId="load-error"
        error={r.error}
        title={t("error.load")}
        action={
          <Button size="small" onClick={r.reload}>
            {t("error.retry")}
          </Button>
        }
      />
    );
  if (r.data === undefined) return <Skeleton active paragraph={{ rows }} />;
  return <>{children(r.data)}</>;
}
